/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { inheritsLoose as _inheritsLoose, wrapNativeSuper as _wrapNativeSuper } from '../_virtual/_rollupPluginBabelHelpers.js';

var OperatorNotFoundError = /*#__PURE__*/function (_Error) {
  function OperatorNotFoundError(operator) {
    var _this;
    _this = _Error.call(this, "Unknown operator " + operator) || this;
    _this.name = OperatorNotFoundError.name;
    return _this;
  }
  _inheritsLoose(OperatorNotFoundError, _Error);
  return OperatorNotFoundError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
var DataValueNotFoundError = /*#__PURE__*/function (_Error2) {
  function DataValueNotFoundError(key) {
    var _this2;
    _this2 = _Error2.call(this, "Field " + key + " is missing or null") || this;
    _this2.name = DataValueNotFoundError.name;
    return _this2;
  }
  _inheritsLoose(DataValueNotFoundError, _Error2);
  return DataValueNotFoundError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
var ValidationFailedError = /*#__PURE__*/function (_Error3) {
  function ValidationFailedError(key, message, error) {
    var _this3;
    var errors = error == null ? void 0 : error.errors.map(function (zodIssue) {
      return {
        message: zodIssue.message,
        path: zodIssue.path.join('.')
      };
    });
    _this3 = _Error3.call(this, "Validation failed for '" + key + "', message: " + message + ", " + (errors ? "error: " + JSON.stringify(error, null, 2) : '  ')) || this;
    _this3.name = 'ValidationFailedError';
    _this3.errors = errors;
    return _this3;
  }
  _inheritsLoose(ValidationFailedError, _Error3);
  return ValidationFailedError;
}(/*#__PURE__*/_wrapNativeSuper(Error));

export { DataValueNotFoundError, OperatorNotFoundError, ValidationFailedError };
//# sourceMappingURL=errors.js.map
